export default __webpack_public_path__ + "static/media/medicines.befb637a.svg";